// @generated by protoc-gen-connect-query v2.3.1 with parameter "target=ts"
// @generated from file travplaces/v1/admin_user.proto (package travplaces.v1, syntax proto3)
/* eslint-disable */

import { AdminUserService } from "./admin_user_pb";

/**
 * ListUsers returns every account and the role it holds.
 *
 * @generated from rpc travplaces.v1.AdminUserService.ListUsers
 */
export const listUsers = AdminUserService.method.listUsers;

/**
 * CreateUser adds an account with an initial password.
 *
 * @generated from rpc travplaces.v1.AdminUserService.CreateUser
 */
export const createUser = AdminUserService.method.createUser;

/**
 * SetUserName changes what an operator is called on screen.
 *
 * @generated from rpc travplaces.v1.AdminUserService.SetUserName
 */
export const setUserName = AdminUserService.method.setUserName;

/**
 * SetUserRole moves an account onto a different role.
 *
 * @generated from rpc travplaces.v1.AdminUserService.SetUserRole
 */
export const setUserRole = AdminUserService.method.setUserRole;

/**
 * ResetUserPassword sets a new password for an account whose holder cannot
 * sign in to change it themselves.
 *
 * @generated from rpc travplaces.v1.AdminUserService.ResetUserPassword
 */
export const resetUserPassword = AdminUserService.method.resetUserPassword;

/**
 * DeleteUser removes an account. Refused for your own account, and refused
 * if it would remove the last account able to manage users.
 *
 * @generated from rpc travplaces.v1.AdminUserService.DeleteUser
 */
export const deleteUser = AdminUserService.method.deleteUser;
